var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00039 0.400391C1.55856 0.400391 1.20039 0.758563 1.20039 1.20039C1.20039 1.64222 1.55856 2.00039 2.00039 2.00039C6.41867 2.00039 10.0004 5.58211 10.0004 10.0004C10.0004 10.4422 10.3586 10.8004 10.8004 10.8004C11.2422 10.8004 11.6004 10.4422 11.6004 10.0004C11.6004 4.69846 7.30232 0.400391 2.00039 0.400391Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20039 5.20039C1.20039 4.75856 1.55856 4.40039 2.00039 4.40039C5.09319 4.40039 7.60039 6.9076 7.60039 10.0004C7.60039 10.4422 7.24222 10.8004 6.80039 10.8004C6.35856 10.8004 6.00039 10.4422 6.00039 10.0004C6.00039 7.79125 4.20953 6.00039 2.00039 6.00039C1.55856 6.00039 1.20039 5.64222 1.20039 5.20039Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 10.0004C0.400391 9.11674 1.11674 8.40039 2.00039 8.40039C2.88405 8.40039 3.60039 9.11674 3.60039 10.0004C3.60039 10.884 2.88405 11.6004 2.00039 11.6004C1.11674 11.6004 0.400391 10.884 0.400391 10.0004Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.b648ac41a747081804b44f0b1e13682e.svg";
export { ForwardRef as ReactComponent };